const excludedTags = new Set(['SCRIPT', 'STYLE']);
const centimeterPattern = /(\d+(\.\d+)?)cm/g;

function convertCmToInchesGlobally(root = document.body) {
  const walk = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
    acceptNode(node) {
      const parentTagName = node.parentElement?.tagName;

      return parentTagName && excludedTags.has(parentTagName)
        ? NodeFilter.FILTER_REJECT
        : NodeFilter.FILTER_ACCEPT;
    },
  });

  let currentNode;
  while ((currentNode = walk.nextNode())) {
    currentNode.nodeValue = (currentNode.nodeValue ?? '').replace(centimeterPattern, (_, value) => {
      const inches = (parseFloat(value) / 2.54).toFixed(2);
      return `${inches}"`;
    });
  }
}

window.convertCmToInchesGlobally = convertCmToInchesGlobally;

const selectedUnit = localStorage.getItem('novu_unit') || 'cm';

if (selectedUnit === 'in') {
  convertCmToInchesGlobally();
}